// ** Icons Import
import { Circle, Percent, User, ShoppingBag } from "react-feather";

export default [
  {
    id: "subscription",
    title: "Subscriptions",
    icon: <ShoppingBag size={20} />,
    badge: "light-warning",
    // badgeText: "2",
    children: [
      {
        id: "subscriptionStats",
        title: "Stats",
        icon: <Circle size={12} />,
        navLink: "/subscription/stats",
      },
      {
        id: "subscriptionUsers",
        title: "Users",
        icon: <Circle size={20} />,
        badge: "light-warning",
        navLink: "/subscription/users",
      },
      {
        id: "promoCode",
        title: "Promo Code",
        icon: <Circle size={20} />,
        badge: "light-warning",
        navLink: "/subscription/promo",
      },
    ],
  },
];
